// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact-textarea .v-label{white-space:break-spaces;font-size:14px;height:-moz-fit-content;height:fit-content}.contact-textarea .v-label.v-label--active{top:10px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
